class Header extends HTMLElement {
  constructor() {
    super();

    this.searchToggleButton = this.querySelector('[data-search-toggle]');
    this.searchBar = this.querySelector('[data-search-bar]');
    this.searchBarInput = this.querySelector('[data-search-bar-input]');
    this.menuToggleButton = this.querySelector('[data-menu-toggle]');
    this.menuToggleButtonText = this.querySelector('[data-menu-toggle-text]');
    this.megaMenu = this.querySelector('[data-megamenu]');
    this.toggleMenu = this.querySelector('[data-toggle-menu]');
    this.toggleMenuParentLinks = this.querySelectorAll('[data-toggle-menu-parent-link]');
    this.toggleMenuChildLinks = this.querySelectorAll('[data-toggle-menu-child-link]');
    this.toggleMenuBackButtons = this.querySelectorAll('[data-toggle-menu-back]');

    this.setOffsetClasses();
    this.setHeaderTransparency();

    this.addEventListener('keyup', (evt) => {
      if (evt.code !== 'Escape') { return; }
      this.closeSearchBar();
      this.closeMenus();
    });

    window.addEventListener('resize', () => this.setOffsetClasses());

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => this.setOffsetClasses());
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('site-header')) { return; }

      this.closeSearchBar();
      this.closeMenus();
    });

    if (this.searchBarCloseButton) {
      this.searchBarCloseButton.addEventListener('click', this.closeSearchBar.bind(this));
    }

    if (this.menuToggleButton) {
      this.menuToggleButton.addEventListener('click', this.toggleMenus.bind(this));
    }

    if (this.toggleMenuParentLinks) {
      this.toggleMenuParentLinks.forEach((toggleMenuParentLink) => {
        toggleMenuParentLink.addEventListener('click', this.openChildMenu.bind(this));
      });
    }

    if (this.toggleMenuChildLinks) {
      this.toggleMenuChildLinks.forEach((toggleMenuChildLink) => {
        toggleMenuChildLink.addEventListener('click', this.openGrandChildMenu.bind(this));
      });
    }

    if (this.toggleMenuBackButtons) {
      this.toggleMenuBackButtons.forEach((toggleMenuBackButton) => {
        toggleMenuBackButton.addEventListener('click', this.goBack.bind(this));
      });
    }

    if (this.toggleMenu) {
      this.toggleMenu.addEventListener('focusout', this.toggleMenuFocusOut.bind(this));
    }

    if (this.megaMenu) {
      this.megaMenu.addEventListener('focusout', this.megaMenuFocusOut.bind(this));
    }

    if (this.searchBar) {
      this.searchBar.addEventListener('focusout', this.searchBarFocusOut.bind(this));
    }

    if (this.searchToggleButton) {
      this.searchToggleButton.addEventListener('click', this.toggleSearchBar.bind(this));
    }
  }

  setHeaderTransparency() {
    if (!this.hasAttribute('data-header-mobile-transparency') && !this.hasAttribute('data-header-desktop-transparency')) { return; }

    window.addEventListener('scroll', () => {
      if (window.scrollY >= 10) {
        if (window.innerWidth >= 1025 && this.hasAttribute('data-header-desktop-transparency')) {
          this.classList.remove('header--desktop-transparent');
        } else if (window.innerWidth < 1025 && this.hasAttribute('data-header-mobile-transparency')) {
          this.classList.remove('header--mobile-transparent');
        }
      } else {
        if (window.innerWidth >= 1025 && this.hasAttribute('data-header-desktop-transparency')) {
          this.classList.add('header--desktop-transparent');
        } else if (window.innerWidth < 1025 && this.hasAttribute('data-header-mobile-transparency')) {
          this.classList.add('header--mobile-transparent');
        }
      }
    });
  }

  setOffsetClasses() {
    document.body.classList.remove('desktop-top-offset', 'desktop-bottom-offset', 'mobile-top-offset', 'mobile-bottom-offset');

    if (window.innerWidth >= 1025 && this.classList.contains('header--desktop-top')) {
      document.body.classList.add('desktop-top-offset');
    } else if (window.innerWidth < 1025 && window.innerWidth >= 768 && this.classList.contains('header--mobile-top')) {
      document.body.classList.add('desktop-top-offset');
    } else if (window.innerWidth < 768 && this.classList.contains('header--mobile-top')) {
      document.body.classList.add('mobile-top-offset');
    }

    if (window.innerWidth >= 1025 && this.classList.contains('header--desktop-bottom')) {
      document.body.classList.add('desktop-bottom-offset');
    } else if (window.innerWidth < 1025 && window.innerWidth >= 768 && this.classList.contains('header--mobile-bottom')) {
      document.body.classList.add('desktop-bottom-offset');
    } else if (window.innerWidth < 768 && this.classList.contains('header--mobile-bottom')) {
      document.body.classList.add('mobile-bottom-offset');
    }
  }

  toggleMenus() {
    this.closeSearchBar();

    if (this.menuToggleButton.hasAttribute('data-menu-text-toggle')) {
      if (this.menuToggleButtonText.innerHTML.indexOf(window.headerStrings.menu) >= 0) {
        this.menuToggleButtonText.innerHTML = window.headerStrings.close;
        this.menuToggleButton.setAttribute('aria-label', `${window.headerStrings.close} ${window.headerStrings.menu}`);
      } else {
        this.menuToggleButtonText.innerHTML = window.headerStrings.menu;
        this.menuToggleButton.setAttribute('aria-label', window.headerStrings.menu);
      }
    }

    if (this.megaMenu) {
      if (this.offsetHeight >= 100) {
        const megaMenuOffset = (parseInt(this.offsetHeight, 10) / 2) + 16;

        this.megaMenu.style.paddingTop = `${megaMenuOffset}px`;
      }

      this.megaMenu.classList.toggle('active');

      if (this.megaMenu.classList.contains('active')) {
        this.classList.add('header--active');
      } else {
        this.classList.remove('header--active');
      }
    }

    this.toggleMenu.classList.toggle('active');
    this.menuToggleButton.classList.toggle('active');

    if (this.toggleMenu.classList.contains('active')) {
      this.classList.add('header--active');

      setTimeout(() => {
        this.classList.add('header--transition-complete');
      }, 200);
    } else {
      this.classList.remove('header--active');
      this.classList.remove('header--transition-complete');
    }

    if(this.megaMenu && window.innerWidth >= 1025) {
      this.megaMenu.focus();
    } else {
      this.toggleMenu.focus();
    }
  }

  closeMenus() {
    window.removeTrapFocus();

    if (this.megaMenu) {
      this.megaMenu.classList.remove('active');
    }

    this.toggleMenu.classList.remove('active');
    this.menuToggleButton.classList.remove('active');

    if (this.menuToggleButton.hasAttribute('data-menu-text-toggle')) {
      this.menuToggleButtonText.innerHTML = window.headerStrings.menu;
      this.menuToggleButton.setAttribute('aria-label', window.headerStrings.menu);
    }

    this.classList.remove('header--active');
    this.classList.remove('header--transition-complete');
  }

  openChildMenu(event) {
    const linksWrapper = event.target.closest('[data-toggle-menu-links]');
    const parentLinkWrapper = event.target.closest('[data-toggle-menu-parent-link-wrapper]');
    const childLinksMenu = parentLinkWrapper.querySelector('[data-toggle-menu-child-menu]');

    linksWrapper.classList.add('toggle-menu__links--child');
    childLinksMenu.classList.remove('d-none');
    childLinksMenu.querySelector('[data-toggle-menu-item]').focus();
  }

  openGrandChildMenu(event) {
    const childLinksMenu = event.target.closest('[data-toggle-menu-child-menu]');
    const childLinkWrapper = event.target.closest('[data-toggle-menu-child-link-wrapper]');
    const grandChildMenu = childLinkWrapper.querySelector('[data-toggle-menu-grandchild-menu]');

    childLinksMenu.classList.add('toggle-menu__links--grandchild');
    grandChildMenu.classList.remove('d-none');
    grandChildMenu.querySelector('[data-toggle-menu-item]').focus();
  }

  goBack(event) {
    const linksWrapper = event.target.closest('[data-toggle-menu-links]');
    const childLinksMenu = event.target.closest('[data-toggle-menu-child-menu]');
    const grandChildMenu = event.target.closest('[data-toggle-menu-grandchild-menu]');

    if (grandChildMenu) {
      childLinksMenu.classList.remove('toggle-menu__links--grandchild');
      grandChildMenu.classList.add('d-none');
      childLinksMenu.querySelector('[data-toggle-menu-item]').focus();
    } else if (childLinksMenu) {
      linksWrapper.classList.remove('toggle-menu__links--child');
      childLinksMenu.classList.add('d-none');
      linksWrapper.querySelector('[data-toggle-menu-item]').focus();
    }
  }

  toggleSearchBar() {
    this.closeMenus();

    this.searchToggleButton.focus();
    this.searchToggleButton.classList.toggle('active');
    this.searchBar.classList.toggle('active');

    if (this.searchBar.classList.contains('active')) {
      this.classList.add('header--active');

      setTimeout(() => {
        this.classList.add('header--transition-complete');
        this.searchBarInput.focus();
      }, 200);

      this.searchToggleButton.setAttribute('aria-label', window.headerStrings.close_search_bar);
    } else {
      this.classList.remove('header--active');
      this.classList.remove('header--transition-complete');
      this.searchToggleButton.setAttribute('aria-label', window.headerStrings.search);
    }
  }

  closeSearchBar() {
    if (!this.searchToggleButton) { return; }

    this.searchToggleButton.classList.remove('active');
    this.searchBar.classList.remove('active');
    this.classList.remove('header--active');
    this.searchToggleButton.setAttribute('aria-label', window.headerStrings.search);
  }

  toggleMenuFocusOut(event) {
    if (!document.body.classList.contains('tab-outline')) { return; }

    if (event.relatedTarget === this.menuToggleButton || event.relatedTarget && event.relatedTarget.closest('[data-toggle-menu]')) { return; }

    this.closeSearchBar();
    this.closeMenus();
  }

  megaMenuFocusOut(event) {
    if (!document.body.classList.contains('tab-outline')) { return; }

    if (event.relatedTarget === this.menuToggleButton || event.relatedTarget && event.relatedTarget.closest('[data-megamenu]')) { return; }

    this.closeSearchBar();
    this.closeMenus();
  }

  searchBarFocusOut(event) {
    if (!document.body.classList.contains('tab-outline')) { return; }

    if (event.relatedTarget === this.searchToggleButton || event.relatedTarget && event.relatedTarget.closest('[data-search-bar]')) { return; }

    this.searchToggleButton.focus();
    this.closeSearchBar();
    this.closeMenus();
  }
}

customElements.define('site-header', Header);

if (!customElements.get('mobile-reversed-logo')) {
  class MobileReversedLogo extends HTMLElement {
    constructor() {
      super();

      this.link = this.querySelector('[data-mobile-reversed-logo-link]');

      this.setMobileReversedLogos();
    }

    setMobileReversedLogos() {
      const header = document.querySelector('site-header');
      const mobileReversedLogoSrc = header.getAttribute('data-mobile-reversed-logo-src');
      const mobileReversedLogoAlt = header.getAttribute('data-mobile-reversed-logo-alt');
      const mobileReversedLogoWidth = header.getAttribute('data-mobile-reversed-logo-width');
      const mobileReversedLogoHeight = header.getAttribute('data-mobile-reversed-logo-height');

      if (mobileReversedLogoSrc) {
        this.link.innerHTML = `<img src="https:${mobileReversedLogoSrc}" alt="${mobileReversedLogoAlt}" loading="lazy" width="${mobileReversedLogoWidth}" height="${mobileReversedLogoHeight}">`;
      } else {
        this.classList.add('hero__logo--text');
        this.link.innerHTML = `<span class="hero__logo-text h5">${this.link.getAttribute('title')}</span>`;
      }
    }
  }

  customElements.define('mobile-reversed-logo', MobileReversedLogo);
}